import React from 'react'

import { Select } from 'antd'
import get from 'lodash/get'

const InputWithArrayValue = React.forwardRef(props => {
  const setFields = get(props, 'setFields')
  const handleChange = values =>
    setFields({
      emails: {
        value: values,
      },
    })

  return (
    <Select
      mode="tags"
      dropdownStyle={{ display: 'none' }}
      onChange={handleChange}
    />
  )
})

export default InputWithArrayValue
